import { FC } from 'react';
import { AppBar as BaseAppBar, FlexContent, SessionTimer, UserSwitcher } from '@prime/core';
import { useHistory } from 'react-router';
import { useTranslation } from 'react-i18next';

import Button from '../form/elements/Button';
import { BUTTON_COLOR, BUTTON_TYPE, BUTTON_VARIANT } from '../form/enum/formProps';
import { ROUTES } from '../../core/router/routes';
import { useGetMeQuery } from '../../core/auth/api/authApi';
import { useAuthLocation } from '../../core/auth/hooks/useAuthLocation';

const AppBar: FC = () => {
  const { data: me } = useGetMeQuery();
  const { userLogout } = useAuthLocation();
  const history = useHistory();
  const { t } = useTranslation();

  return (
    <BaseAppBar
      collapsed={true}
      disableToggle={true}
      onLogoClick={() => {
        history.push(ROUTES.DASHBOARD);
      }}
    >
      <UserSwitcher label={me?.username}>
        <FlexContent justify="space-between">
          <Button variant={BUTTON_VARIANT.TEXT} text={t('button.go_back')} onClick={() => history.goBack()} />
          <Button
            onClick={() => userLogout()}
            color={BUTTON_COLOR.PRIMARY}
            type={BUTTON_TYPE.BUTTON}
            variant={BUTTON_VARIANT.CONTAINED}
            text="auth.logout"
          />
        </FlexContent>
      </UserSwitcher>
      <SessionTimer onSessionExpired={userLogout} />
    </BaseAppBar>
  );
};

export default AppBar;
